var Theme = Theme || {};

Theme.CrossmarkButton = (function ($) {
    return {
        init: _init
    };

    function _init() {
        $('.js-crossmark-button[aria-disabled="true"]')
            .removeAttr('aria-disabled')
            .removeAttr('tabindex');
    }
})(jQuery);
